import React from "react";

import simplilearn from "../IMG/simplilearn.jpeg";
import nptel from "../IMG/NPTEL.jpeg";
import great_learning from "../IMG/great_learning.jpeg";
import NIELIT from "../IMG/NIELIT.jpeg";
import oracle from "../IMG/oracle.png";
import Mckinsey from "../IMG/Mckinsey.png";

function Certificate() {
  return (
    <>
      {/* SEO META TAGS (NO UI CHANGE) */}


      {/* UI — EXACTLY THE SAME */}
      <div className="pb-6 px-4">
        <div className="pb-4 md:pb-4 md:pt-4 px-6 pt-2 bg-white shadow-md rounded-md">
          <div>
            <h1 className="text-xl font-bold text-gray-800 my-4 tracking-wide">
              Additional Qualification
            </h1>

            <div className="space-y-6">
              {[
                {
                  img: Mckinsey,
                  title: "McKinsey.org Forward Program",
                  company: "McKinsey & Company",
                  issue: "December 2025",
                },
                {
                  img: oracle,
                  title:
                    "Oracle Cloud Infrastructure 2025 Certified Developer Professional",
                  company: "Oracle",
                  issue: "October 2025",
                },
                {
                  img: simplilearn,
                  title: "Introduction to MERN Stack",
                  company: "Simplilearn",
                  issue: "December 2024",
                },
                {
                  img: nptel,
                  title: "Software Testing offered by IIT Kharagpur",
                  company: "NPTEL",
                  issue: "April 2024",
                },
                {
                  img: great_learning,
                  title: "Android Application Development",
                  company: "Great Learning",
                  issue: "January 2024",
                },
                {
                  img: NIELIT,
                  title: "Course on Computer Concepts (CCC)",
                  company:
                    "National Institute of Electronics & Information Technology (NIELIT)",
                  issue: "October 2018",
                },
              ].map((cer, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 p-5 bg-gray-50 rounded-md shadow-sm hover:shadow-md transition-all duration-200"
                >
                  <img
                    src={cer.img}
                    alt={`${cer.company} certificate`}
                    className="w-14 rounded-md"
                  />
                  <div className="flex-1">
                    <h2 className="text-xl font-semibold text-gray-800">
                      {cer.title}
                    </h2>
                    <p className="text-lg font-semibold text-gray-700">
                      {cer.company}
                    </p>
                    <p className="text-base text-gray-500 italic">
                      {cer.issue}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex mt-4">
              <button className="px-6 py-2 bg-blue-500 text-white font-semibold rounded-md shadow hover:bg-blue-600 transition">
                <a
                  href="https://www.linkedin.com/in/sriakshat5/details/certifications/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Load More
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Certificate;
